<template>
  <span>
    <b-card no-body>
      <b-card-header>
       <b-row>
          <b-col md="9">
            <h3>Relatório Mensal do Município</h3>
          </b-col>
          <b-col md="3">
            <p><b>Nome:</b> {{ usuarioLogado.nome }}</p>
            <p><b>Perfil:</b> {{ usuarioLogado.perfil }}</p>
            <p><b>Estado:</b> {{ usuarioLogado.estado }}</p>
            <p><b>Município:</b> {{ usuarioLogado.municipio }}</p>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-form v-on:submit.prevent="onSubmit">
          <b-row>
            <b-col sm="2">
              <b-form-group label="Mês: *">
                <b-form-select  v-model="$v.form.mes.$model" :options="listames" class="mb-3">
                <option selected :value="null">Selecione</option>
                </b-form-select>
                  <b-form-invalid-feedback
                    :state="chkState('mes')"
                    id="input1LiveFeedback1"
                    >Mês é obrigatório.</b-form-invalid-feedback
                  >
              </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group label="Ano: *">
                <b-form-select  v-model="$v.form.ano.$model"  class="mb-3">
                <option selected :value="null">Selecione</option>
                <option v-for="item in listaAno" :key="item.value" :value="item.value">{{item.name}}</option>
                </b-form-select>
                  <b-form-invalid-feedback
                    :state="chkState('ano')"
                    id="input1LiveFeedback1"
                    >Ano é obrigatório.</b-form-invalid-feedback
                  >
              </b-form-group>
            </b-col>
          <b-col v-if="form.resposta" offset-md="4" md="4">
           <p><b>Considerações:</b></p>
           <p class="font-italic">{{ form.resposta}}</p>
          </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <b-form-group label="Qntd. Atendimento Realizados: *">
                <b-input-group class="mb-6">
                  <b-form-input
                    type="number"
                    class="form-control"
                    v-model="$v.form.qtd_atendimento_realizado.$model"
                    :max="limit"
                    :state="chkState('qtd_atendimento_realizado')"
                    autofocus
                  />
                  <b-form-invalid-feedback id="input1LiveFeedback5"
                    >Qntd. Atendimento Realizados é obrigatório.</b-form-invalid-feedback
                  >
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <b-form-group label="Qntd. de novas voluntárias: *">
                <b-input-group class="mb-6">
                  <b-form-input
                    type="number"
                    class="form-control"
                    :max="limit"
                    v-model="$v.form.qtd_novas_voluntarias.$model"
                    :state="chkState('qtd_novas_voluntarias')"
                    autofocus
                  />
                  <b-form-invalid-feedback id="input1LiveFeedback5"
                    >Qntd. de novas voluntárias é obrigatório.</b-form-invalid-feedback
                  >
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <b-form-group label="Qntd. de novas beneficiárias: *">
                <b-input-group class="mb-6">
                  <b-form-input
                    type="number"
                    class="form-control"
                    :max="limit"
                    v-model="$v.form.qtd_novas_beneficiarias.$model"
                    :state="chkState('qtd_novas_beneficiarias')"
                    autofocus
                  />
                  <b-form-invalid-feedback id="input1LiveFeedback5"
                    >Qntd. de novas beneficiárias é obrigatório.</b-form-invalid-feedback
                  >
                </b-input-group>
              </b-form-group>
            </b-col>
            </b-row>
            <b-row>
            <b-col cols="3">
              <b-form-group label="Qntd. de novas beneficiárias que tem menos de 18 anos: *">
                <b-input-group class="mb-6">
                  <b-form-input
                    type="number"
                    class="form-control"
                    :max="limit"
                    v-model="$v.form.qtd_novas_beneficiarias_menor.$model"
                    :state="chkState('qtd_novas_beneficiarias_menor')"
                    autofocus
                  />
                  <b-form-invalid-feedback id="input1LiveFeedback5"
                    >Qntd. de novas beneficiárias que tem menos de 18 anos é obrigatório.</b-form-invalid-feedback
                  >
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <b-form-group label="Qntd. de novas beneficiárias que participam de programas sociais: *">
                <b-input-group class="mb-6">
                  <b-form-input
                    type="number"
                    class="form-control"
                    :max="limit"
                    v-model="$v.form.qtd_novas_beneficiarias_participantes_sociais.$model"
                    :state="chkState('qtd_novas_beneficiarias_participantes_sociais')"
                    autofocus
                  />
                  <b-form-invalid-feedback id="input1LiveFeedback5"
                    >Qntd. de novas beneficiárias que participam de programas sociais é obrigatório.</b-form-invalid-feedback
                  >
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <b-form-group label="Qntd. de novas beneficiárias que possuem crianças com deficiência ou doenças raras: *">
                <b-input-group class="mb-6">
                  <b-form-input
                    type="number"
                    :max="limit"
                    class="form-control"
                    v-model="$v.form.qtd_novas_beneficiarias_criancas_deficiencia.$model"
                    :state="chkState('qtd_novas_beneficiarias_criancas_deficiencia')"
                    autofocus
                  />
                  <b-form-invalid-feedback id="input1LiveFeedback5"
                    >Qntd. de novas beneficiárias que possuem crianças com deficiência ou doenças raras é obrigatório.</b-form-invalid-feedback
                  >
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <b-form-group label="Qntd. de novas beneficiárias que possuem filhos com menos de 18 anos: *">
                <b-input-group class="mb-6">
                  <b-form-input
                    type="number"
                    class="form-control"
                    :max="limit"
                    v-model="$v.form.qtd_novas_beneficiarias_criancas_menor.$model"
                    :state="chkState('qtd_novas_beneficiarias_criancas_menor')"
                    autofocus
                  />
                  <b-form-invalid-feedback id="input1LiveFeedback5"
                    >Qntd. de novas beneficiárias que possuem filhos com menos de 18 anos é obrigatório.</b-form-invalid-feedback
                  >
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col md="3" offset-md="3">
            <b-button block variant="primary" v-on:click="onSubmit">
              <i class="fa fa-check"></i>&nbsp;
              <span>Salvar</span>
            </b-button>
          </b-col>
          <b-col md="3">
            <b-button block variant="secondary" @click="$router.go(-1)">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span
                >Voltar</span
              >
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </span>
</template>

<script>
import 'v-markdown-editor/dist/v-markdown-editor.css'
import Vue from 'vue'
import AuthTemplate from '@/templates/auth/AuthTemplate'
import VueSelect from 'vue-select'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Editor from 'v-markdown-editor'
import CKEditor from 'ckeditor4-vue'
import SessionStorage from '@/services/session-storage'

miniToastr.init()
Vue.use(Editor)
Vue.use(CKEditor)

const formShape = {
  mes: null,
  ano: null,
  qtd_atendimento_realizado: 0,
  qtd_novas_voluntarias: 0,
  qtd_novas_beneficiarias: 0,
  qtd_novas_beneficiarias_menor: 0,
  qtd_novas_beneficiarias_participantes_sociais: 0,
  qtd_novas_beneficiarias_criancas_deficiencia: 0,
  qtd_novas_beneficiarias_criancas_menor: 0
}

export default {
  name: 'Cadastro',
  components: {
    AuthTemplate,
    VueSelect,
    Editor
  },
  mixins: [validationMixin],
  validations: {
    form: {
      mes: {
        required
      },
      ano: {
        required
      },
      qtd_atendimento_realizado: {
        required
      },
      qtd_novas_voluntarias: {
        required
      },
      qtd_novas_beneficiarias: {
        required
      },
      qtd_novas_beneficiarias_menor: {
        required
      },
      qtd_novas_beneficiarias_participantes_sociais: {
        required
      },
      qtd_novas_beneficiarias_criancas_deficiencia: {
        required
      },
      qtd_novas_beneficiarias_criancas_menor: {
        required
      }
    }
  },
  created () {
    if (SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') !== 'P' && SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') !== 'L') {
      this.$router.push('/')
    }
    this.$store.dispatch('buscarMunicipiosProgramas')
    this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
  },
  data () {
    return {
      form: Object.assign({}, formShape),
      id: null,
      limit: 10000,
      listames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      editorConfig: {
        removePlugins: 'elementspath,resize,codesnippet'
      },
      usuarioLogado: {
        municipio: '',
        estado: '',
        perfil: '',
        nome: ''
      },
      listaAno: []
    }
  },
  mounted () {
    if (typeof this.$route.params.id !== 'undefined') {
      this.load(this.$route.params.id)
    }
    let anoAtual = new Date()
    for (let i = 0; i < 5; i++) {
      this.listaAno.push({value: anoAtual.getFullYear() - i, name: anoAtual.getFullYear() - i})
    }
  },
  computed: {
    isValid () {
      return !this.$v.form.$anyError
    },
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    },
    municipiosprogramas () {
      return this.$store.state.municipiosprogramas.listaMunicipiosProgramas
    }
  },
  watch: {
    'usuario.perfil': function () {
      this.usuarioLogado.perfil = this.usuario.perfil.nome
      this.usuarioLogado.nome = this.usuario.nome
    },
    municipiosprogramas: function () {
      this.municipiosprogramas.forEach((element) => {
        if (
          element.municipio_id ===
          this.usuario.dados_pessoais.municipio_atuacao_id
        ) {
          this.usuarioLogado.estado = element.estado.estado
          this.usuarioLogado.municipio = element.cidade.cidade
        }
      })
    },
    '$v.form.qtd_novas_beneficiarias.$model': function (val) {
      this.$v.form.qtd_novas_beneficiarias.$model = (val.replace(/\D/g, '')).replace(/^0+(?!\.|$)/, '')
      if (String(this.$v.form.qtd_novas_beneficiarias.$model).length > 6) { this.$v.form.qtd_novas_beneficiarias.$model = String(val).substr(0, 5) }
    },
    '$v.form.qtd_atendimento_realizado.$model': function (val) {
      this.$v.form.qtd_atendimento_realizado.$model = (val.replace(/\D/g, '')).replace(/^0+(?!\.|$)/, '')
      if (String(this.$v.form.qtd_atendimento_realizado.$model).length > 6) { this.$v.form.qtd_atendimento_realizado.$model = String(val).substr(0, 5) }
    },
    '$v.form.qtd_novas_voluntarias.$model': function (val) {
      this.$v.form.qtd_novas_voluntarias.$model = (val.replace(/\D/g, '')).replace(/^0+(?!\.|$)/, '')
      if (String(this.$v.form.qtd_novas_voluntarias.$model).length > 6) { this.$v.form.qtd_novas_voluntarias.$model = String(val).substr(0, 5) }
    },
    '$v.form.qtd_novas_beneficiarias_menor.$model': function (val) {
      this.$v.form.qtd_novas_beneficiarias_menor.$model = (val.replace(/\D/g, '')).replace(/^0+(?!\.|$)/, '')
      if (String(this.$v.form.qtd_novas_beneficiarias_menor.$model).length > 6) { this.$v.form.qtd_novas_beneficiarias_menor.$model = String(val).substr(0, 5) }
    },
    '$v.form.qtd_novas_beneficiarias_participantes_sociais.$model': function (val) {
      this.$v.form.qtd_novas_beneficiarias_participantes_sociais.$model = (val.replace(/\D/g, '')).replace(/^0+(?!\.|$)/, '')
      if (String(this.$v.form.qtd_novas_beneficiarias_participantes_sociais.$model).length > 6) { this.$v.form.qtd_novas_beneficiarias_participantes_sociais.$model = String(val).substr(0, 5) }
    },
    '$v.form.qtd_novas_beneficiarias_criancas_deficiencia.$model': function (val) {
      this.$v.form.qtd_novas_beneficiarias_criancas_deficiencia.$model = (val.replace(/\D/g, '')).replace(/^0+(?!\.|$)/, '')
      if (String(this.$v.form.qtd_novas_beneficiarias_criancas_deficiencia.$model).length > 6) { this.$v.form.qtd_novas_beneficiarias_criancas_deficiencia.$model = String(val).substr(0, 5) }
    },
    '$v.form.qtd_novas_beneficiarias_criancas_menor.$model': function (val) {
      this.$v.form.qtd_novas_beneficiarias_criancas_menor.$model = (val.replace(/\D/g, '')).replace(/^0+(?!\.|$)/, '')
      if (String(this.$v.form.qtd_novas_beneficiarias_criancas_menor.$model).length > 6) { this.$v.form.qtd_novas_beneficiarias_criancas_menor.$model = String(val).substr(0, 5) }
    },
    'usuario.dados_pessoais': function () {
      this.municipiosprogramas.forEach((element) => {
        if (
          element.municipio_id ===
          this.usuario.dados_pessoais.municipio_atuacao_id
        ) {
          this.usuarioLogado.estado = element.estado.estado
          this.usuarioLogado.municipio = element.cidade.cidade
        }
      })
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    salvar () {
      let form = this.$v.form

      let data = {
        id: this.id,
        ano: form.ano.$model,
        mes: form.mes.$model,
        qtd_atendimento_realizado: form.qtd_atendimento_realizado.$model,
        qtd_novas_voluntarias: form.qtd_novas_voluntarias.$model,
        qtd_novas_beneficiarias: form.qtd_novas_beneficiarias.$model,
        qtd_novas_beneficiarias_menor: form.qtd_novas_beneficiarias_menor.$model,
        qtd_novas_beneficiarias_participantes_sociais: form.qtd_novas_beneficiarias_participantes_sociais.$model,
        qtd_novas_beneficiarias_criancas_deficiencia: form.qtd_novas_beneficiarias_criancas_deficiencia.$model,
        qtd_novas_beneficiarias_criancas_menor: form.qtd_novas_beneficiarias_criancas_menor.$model
      }

      Vue.http
        .post('api/relatoriomensal', data)
        .then((response) => {
          if (response.body.success) {
            miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
            if (this.cadastroInterno) {
              miniToastr.success(
                'Relatório salvo com sucesso!',
                'Sucesso!',
                7000
              )
            } else {
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
            }

            this.$router.push({ path: '/relatorio-mensal' })
          } else {
            this.disable_buttons = false
            miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
            miniToastr.error(response.body.msg, 'Alerta', 5000)
          }
        })
        .catch((e) => {
          console.log('Servidor está fora! ' + e)
        })
    },
    load (id) {
      Vue.http.get('api/relatoriomensal/' + id).then((response) => {
        this.form.ano = response.body.data[0].ano
        this.form.mes = response.body.data[0].mes
        this.form.resposta = response.body.data[0].resposta
        this.form.qtd_atendimento_realizado = response.body.data[0].qtd_atendimento_realizado
        this.form.qtd_novas_voluntarias = response.body.data[0].qtd_novas_voluntarias
        this.form.qtd_novas_beneficiarias = response.body.data[0].qtd_novas_beneficiarias
        this.form.qtd_novas_beneficiarias_menor = response.body.data[0].qtd_novas_beneficiarias_menor
        this.form.qtd_novas_beneficiarias_participantes_sociais = response.body.data[0].qtd_novas_beneficiarias_participantes_sociais
        this.form.qtd_novas_beneficiarias_criancas_deficiencia = response.body.data[0].qtd_novas_beneficiarias_criancas_deficiencia
        this.form.qtd_novas_beneficiarias_criancas_menor = response.body.data[0].qtd_novas_beneficiarias_criancas_menor
        this.id = response.body.data[0].id
      })
    },
    confirmar () {
      this.$bvModal
        .msgBoxConfirm('Tem certeza que deseja continuar?', {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        })
        .then((valor) => {
          if (valor) {
            this.salvar()
          }
        })
        .catch((erro) => {
          console.log(erro)
        })
    },
    onSubmit () {
      if (this.validate()) {
        this.confirmar()
      }
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/relatorioMensal/RelatorioForm.vue